import React, { Component } from 'react';
import { Theme } from '@mui/material';
import { Card, CardContent } from '@mui/material';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../setup';
import { createStyles, withStyles } from '@mui/styles';
import { FormType } from '../../../constants/constants';
import { resetInvoices } from '../../../reducers/invoiceReducer';
import InvoiceForm from './invoiceForm';

interface IAddInvoiceProps {
    classes: any;
    theme: Theme;
    match: any;
    resetInvoices: any;
    steps: Array<number>;
    invoiceId?: number;
    customerId?: number;
    type: FormType;
}

const styles = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        marginTop: '70px',
        display: 'flex'
    },
    cardContent: {
        flex: 1,
        borderTop: '1px #ececec solid',
        borderBottom: 'none',
        marginRight: theme.spacing(5),
        marginLeft: theme.spacing(5)
    }
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    resetInvoices: () => dispatch(resetInvoices())
});

const mapStoreToProps = (store: RootState, ownProps: IAddInvoiceProps) => {
    return {
        invoiceId: ownProps.match.params?.invoiceId ? Number(ownProps.match.params?.invoiceId) : undefined,
        customerId: ownProps.match.params?.customerId ? Number(ownProps.match.params?.customerId) : undefined
    };
};

class AddInvoice extends Component<IAddInvoiceProps> {
    componentWillUnmount() {
        const { resetInvoices } = this.props;

        resetInvoices();
    }

    render() {
        const { classes, steps, invoiceId, type, customerId } = this.props;

        return (
            <Card className={classes.root}>
                <CardContent className={classes.cardContent}>
                    <InvoiceForm invoiceId={invoiceId} steps={steps} type={type} customerId={customerId} />
                </CardContent>
            </Card>
        );
    }
}
  
export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(AddInvoice));